import { Component, OnInit, Compiler, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { ViewDashboardService } from './view-dashboard.service';
import { environment as ENV } from '../../../environments/environment';
import { AddCoapplicantComponent } from '../add-coapplicant/add-coapplicant.component'
import { AuthService } from 'app/laas/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddCustomerService } from '../add-customer/add-customer.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminAuthService } from '../admin-auth.service';
// import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
// import { AddCoapplicantComponent} from '../add-coapplicant/add-coapplicant.component'
import { MatLegacySlideToggleChange } from '@angular/material/legacy-slide-toggle';
import { ApplicantService } from 'app/laas/applicant.service';
import * as moment from 'moment';
import { AdminService } from '../admin.service';
import { CommonFieldsService } from 'app/laas/common-fields.service';
import { TokenServiceService } from 'app/token-service.service';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';
import * as constants from '../../constant'
@Component({
  selector: 'wl-loader-dialog',
  template: `
    <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;"
    >
      <i
        class="fa fa-spinner fa-pulse fa-2x fa-fw"
        style="color:#506c84;margin:0 auto;display:block;"
      ></i>
      <p>Loading Data For the First time.. Please Wait..</p>
    </div>
  `,
})
export class LoaderDialogDashComponent {
  message: string;

  constructor(
    // public dialogRef: MatDialogRef<LoaderDialogComponent>
    public bsModalRef: BsModalRef
  ) {}
}

@Component({
  selector: 'wl-view-dashboard',
  templateUrl: './view-dashboard.component.html',
  styleUrls: ['./view-dashboard.component.scss'],
  providers: [
    ViewDashboardService,
    AddCustomerService,
    ApplicantService,
    AdminService,
    CommonFieldsService,
  ],
})
export class ViewDashboardComponent implements OnInit {
  allUsers: Observable<any>;
  allUsers1: Observable<any>;
  loading: boolean;
  search = new UntypedFormControl();
  rocCount: number;
  credCount: number;
  page: number = 1;
  totalPage: number = 1;
  totalCount: number;
  noUserFound: string;
  reportLink: string;
  adminId: any;
  custId: any;
  iscredCount: boolean;
  showOrHide: boolean;
  placeHolder: string;
  searchHolder: string;
  roleId: string;
  role: string;
  limit: number = 10;
  offset: number = 0;

  userName: string;
  display: boolean;
  typeText: string;
  adminForm: UntypedFormGroup;
  type: any;
  bsModalRef: BsModalRef;
  isRetail: boolean;
  useDefault: boolean;
  status: string;
  pageId: any = 1;
  @ViewChild('date1') firstDate: ElementRef;
  selectedDate: any;
  showSelectedDate: boolean;
  currentDate: String;
  empty: any = [];
  styleDaa: any;
  subheading1: string;
  subheading2: string;
  filterForm: UntypedFormGroup;
  distnew: any;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showDashboardDataTable: boolean = true;
  filter: string = '';

  constructor(
    private customer: ViewDashboardService,
    private dialog: MatDialog,
    private auth: AuthService,
    private router: Router,
    private jwt: JwtHelperService,
    private snackbar: MatSnackBar,
    private cust: AdminAuthService,
    private fb: UntypedFormBuilder,
    // public modalService: NgbModal
    private modalService: BsModalService,
    private applicant: ApplicantService,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private common: CommonFieldsService,
    private token: TokenServiceService,
    private advancedFilterService: AdvancedFilterService
  ) {
    this.adminForm = this.fb.group({
      custId: ['', Validators.required],
      name: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]+')])],
      email: [''],
      mobileNo: [''],

      resAdd: [''],
      offAdd: [''],
      resUnitNo: [''],
      offUnitNo: [''],
      employeeName: [''],
      employeeId: [''],
    });

    this.filterForm = this.fb.group({
      access_level: [''],
      zrbCode: [''],
    });

    this.iscredCount = ENV.creditScoreSetting.credCount;
    if (ENV.creditScoreSetting.credMenu == 'shfl') {
      this.showOrHide = false;
    } else {
      this.showOrHide = true;
    }

    this.searchHolder = 'Search Applicant by Name';

    this.display = false;
  }

  onSearch(value: string) {
    this.filter = value;

    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.page = 1;
    this.pageId = 1;
    this.loading = true;

    this.customer.getUsers(value, this.roleId, 0, 10).subscribe({
      next: (res) => {
        this.loading = false;

        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          
          this.allUsers = res.result.resultData || [];
          this.totalCount = res.result.count || 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = res.result.resultData || [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      error: (err) => {
        this.totalCount = 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        this.loading = false;
        throw err;
      },
    });
  }

  accessSelected(value) {
    console.log('event working', value);
  }

  getAccessLevel() {
    this.adminservice.getAccessLevelList().subscribe((response) => {
      console.log('Access level list response', response);
      if (response && response.success && response.result) {
        this.distnew = response.result;
      }
    });
  }

  addFilter(formDirective: FormGroupDirective) {
    let value = { ...this.filterForm.value };
    console.log(value);
  }

  clearInputs() {
    this.filterForm.reset();
  }

  onSearchClick(event) {
    this.loading = true;
  }

  ngOnInit() {
    this.roleId = this.customer.getRoleId();
    if (this.isCoLogin()) {
      this.showDashboardDataTable = false;
    }
    sessionStorage.removeItem('filterDateDashboardStart');
    sessionStorage.removeItem('filterDateDashboardEnd');
    this.maxDate = this.adminservice.getCurrentMonth();
    this.getAccessLevel();
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();
    let selectedState = '';
    this.token.selectedstateCode.subscribe((value) => {
      selectedState = value;
    });
    console.log(selectedState);

    if (window.addEventListener) {
      window.addEventListener('storage', this.storageListener, false);
    }
    sessionStorage.setItem('submitted', '');
    this.currentDate = moment().format('YYYY-MM');

    var encrypted = sessionStorage.getItem('ubknknsviubi--131ss');
    console.log('decrypted ' + JSON.stringify(atob(encrypted)));

    this.role = sessionStorage.getItem('wzbvdsjvbbs');
    console.log('role ' + this.role);
    if (sessionStorage.getItem('filterDateDashboard')) {
      this.currentDate = moment(sessionStorage.getItem('filterDateDashboard'), 'YYYY-MM-DD').format(
        'YYYY-MM'
      );
      let selected = this.currentDate;
      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      var another = months[+selected.split('-')[1] - 1];
      this.selectedDate = another + ', ' + selected.split('-')[0];
      this.showSelectedDate = true;
    }

    this.roleId = sessionStorage.getItem('getroleId');
    console.log('this.roleId ' + this.roleId);
    // getUsers("", roleId,offset/,limit)
    !this.isCoLogin() && this.getAllUsers('', this.roleId, 0, 10);
    // this.getRocCount();
    // this.applicant = null;
    // sessionStorage.removeItem('wl-applicant-id');
    // sessionStorage.removeItem('wl-custId');

    this.placeHolder = ENV.placeHolderSetting.placeholder;

    this.adminId = sessionStorage.getItem('wl-admin-id');
  }
  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateDashboardStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateDashboardEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      this.showSelectedDate = true;
      let dateType = 'dateRange';
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getUsersFilterDate('', this.roleId, 0, 10, this.dateInMs, this.endDateInMs, dateType)
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            if (res && res.result && res.result.resultData) {
              this.allUsers = res.result.resultData ? res.result.resultData : '';
              this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
              this.totalPage = Math.ceil(this.totalCount / 10);
            }
          } else if (res && res.result == null) {
            // this.allUsers = this.getEmptyArray()
            this.closeButtonClick();
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  // submitDates() {
  //   if(this.firstDate.nativeElement.value <= this.maxDate && this.firstDate.nativeElement.value >= '2022-01'  ){
  //   this.showSelectedDate = true;
  //   console.log('our', this.maxDate)
  //   console.log(this.firstDate.nativeElement.value);
  //   let selected = this.firstDate.nativeElement.value;
  //   var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  //   var another = months[+selected.split('-')[1] - 1];
  //   this.selectedDate = another + ', ' + selected.split('-')[0];
  //   let filterDate = this.firstDate.nativeElement.value + '-01';
  //   console.log('filterdaate', filterDate);
  //   sessionStorage.setItem('filterDateDashboard', filterDate)
  //   let date = new Date(filterDate);
  //   let dateInMs = date.getTime();
  //   console.log('check date', dateInMs);
  //   this.customer.getUsersFilterDate("", this.roleId, 0, 10, dateInMs).subscribe(res => {
  //     console.log(res);
  //     if(res && res.result && res.result.resultData){
  //       if(res && res.result && res.result.resultData){
  //         this.allUsers = res.result.resultData?res.result.resultData:"";
  //         this.totalCount = res && res.result && res.result.count?res.result.count:0;
  //         this.totalPage = Math.ceil(this.totalCount / 10);
  //       }
  //     }else if(res && res.result==null){
  //       // this.allUsers = this.getEmptyArray()
  //       this.closeButtonClick()
  //       this.snackbar.open("No Applicants found. The Filter is not Applied",'OK', {duration:4000})
  //     }
  //   })
  // }else{
  //   this.snackbar.open("Please enter the valid date",'OK', {duration:4000})
  // }
  // }

  getEmptyArray() {
    return of(this.empty);
  }

  getAllUsers(input, roleId, offset, limit) {
    this.loading = true;
    // this.page = pageId;

    this.customer.getUsers(input, roleId, offset, limit).subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
        }

        // if(res && res.count && res.result.count){
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        console.log('this.totalPage ' + this.totalPage);
        // }

        // this.custId = res.result.custId;
        // console.log("custId " +  res.result.custId);
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }
    
    this.pageId = pageId;
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit).subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
          this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log('this.totalPage ' + this.totalPage);
        }
        // this.custId = res.result.custId;
        // console.log("custId " +  res.result.custId);
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getRocCount() {
    this.customer.getRocCounts().subscribe((res) => {
      this.rocCount = res;
    });
  }

  getLogReport() {
    const data = {
      custId: this.adminId,
      type: 1,
    };
    // const message = "data"
  }

  retailCheck(isRetail) {
    console.log('retail...1 ', isRetail);
    // this.customer.isRetail = isRetail;
    if (isRetail == true) {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'tDrfsud25362htsjddh');
    } else {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'fFywshdssf7d9123dnd');
    }
  }
  openDialog(customerId, type, isRetail) {
    console.log('customer id === > ', customerId);
    console.log('type === > ', type);
    console.log('isRetail === > ', isRetail);
    const data = {
      custId: customerId,
      type: type,
      isRetail: isRetail,
    };

    this.bsModalRef = this.modalService.show(AddCoapplicantComponent, {
      animated: false,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: data,
    });
    this.bsModalRef.content.onClose.subscribe((result) => {
      console.log('results', result);
    });
  }

  getType(app, coapp, guarantor) {
    if (app) {
      return 'Applicant';
    } else if (coapp) {
      return 'Co-Applicant';
    } else {
      return 'Guarantor';
    }
  }

  public ConsentRecievedStatus(event: MatLegacySlideToggleChange, userid) {
    console.log('toggle', event.checked, 'userid', userid);
    this.useDefault = event.checked;
  }

  public BranchConsentRenewalStatus(event: MatLegacySlideToggleChange, userid) {
    console.log('toggle', event.checked, 'userid', userid);
    this.useDefault = event.checked;
  }

  openConsent(applicantId, status) {
    this.loading = true;
    console.log('Status toggle', applicantId);
    // this.status = status == "yes" ? "no" : "yes";
    sessionStorage.setItem('applicantId', applicantId);
    sessionStorage.setItem('wl-applicant-id', applicantId);

    if (status == 'pending' || status == 'no') {
      sessionStorage.setItem('lrOpenedFromAdmin', 'false');
      window.open(ENV.urlSetting.url + 'laas/consent-form');
    }
    this.loading = false;
  }

  toggleApprovalStatus(applicantId, status) {
    this.loading = true;
    console.log('Status toggle', status);
    this.status = status == 'approved' ? 'rejected' : 'approved';

    this.applicant
      .toggleStatus(applicantId, 'consent_approval_status', this.status)
      .subscribe((res) => {
        console.log('response toggle', res);
        if (res && res.success == true) {
          this.loading = false;
          this.ngOnInit();
        }
      });
  }
  // user?.docs?.assets?.bhoomi?.files?.length
  checkforlandrecordstatus(i) {
    if (
      (this.allUsers &&
        this.allUsers[i] &&
        this.allUsers[i]['docs'] &&
        this.allUsers[i]['docs']['assets'] &&
        this.allUsers[i]['docs']['assets']['bhoomi'] &&
        this.allUsers[i]['docs']['assets']['bhoomi']['files'] &&
        this.allUsers[i]['docs']['assets']['bhoomi']['files'].length) ||
      (this.allUsers &&
        this.allUsers[i] &&
        this.allUsers[i]['docs'] &&
        this.allUsers[i]['docs']['assets'] &&
        this.allUsers[i]['docs']['assets']['bhoomi_land'] &&
        this.allUsers[i]['docs']['assets']['bhoomi_land']['files'] &&
        this.allUsers[i]['docs']['assets']['bhoomi_land']['files'].length)
    ) {
      // console.log(this.allUsers[i]['docs']['assets'], 'length');

      return 'YES';
    } else {
      // console.log(this.allUsers[i]['docs'],'lengthddddddddddddddd');
      return 'NO';
    }
  }

  getLRStyle(i) {
    if (
      (this.allUsers &&
        this.allUsers[i] &&
        this.allUsers[i]['docs'] &&
        this.allUsers[i]['docs']['assets'] &&
        this.allUsers[i]['docs']['assets']['bhoomi'] &&
        this.allUsers[i]['docs']['assets']['bhoomi']['files'] &&
        this.allUsers[i]['docs']['assets']['bhoomi']['files'].length) ||
      (this.allUsers &&
        this.allUsers[i] &&
        this.allUsers[i]['docs'] &&
        this.allUsers[i]['docs']['assets'] &&
        this.allUsers[i]['docs']['assets']['bhoomi_land'] &&
        this.allUsers[i]['docs']['assets']['bhoomi_land']['files'] &&
        this.allUsers[i]['docs']['assets']['bhoomi_land']['files'].length)
    ) {
      // console.log(this.allUsers[i]['docs']['assets'], 'length');

      return { color: 'black', 'text-align': 'center', 'pointer-events': 'none' };
    } else {
      // console.log(this.allUsers[i]['docs'],'lengthddddddddddddddd');
      return {
        color: 'blue',
        'text-decoration': 'underline',
        'text-align': 'center',
        cursor: 'pointer',
      };
    }
  }

  checkConsentStatus(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let fb = this.allUsers[i].consent_feedback_status;
      /* console.log(fb) */
      if (fb && fb == 'yes') {
        return fb.toUpperCase();
      } else if (fb && fb == 'no') {
        return fb.toUpperCase();
      } else if (fb && fb == 'pending') {
        return 'DNR';
      }
    }
  }

  getConsentStyle(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let fb = this.allUsers[i].consent_feedback_status;
      /* console.log(fb) */
      if (fb && fb == 'yes') {
        return { color: 'black', 'text-align': 'center', 'pointer-events': 'none' };
      } else if (fb && fb == 'no') {
        return {
          color: 'blue',
          'text-decoration': 'underline',
          'text-align': 'center',
          cursor: 'pointer',
        };
      } else if (fb && fb == 'pending') {
        return {
          color: 'blue',
          'text-decoration': 'underline',
          'text-align': 'center',
          cursor: 'pointer',
        };
      }
    }
  }

  getProcessingStatus(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let user = this.allUsers[i];
      let finalAssLimit =
        user && user.final_form_submitted_data && user.final_form_submitted_data.final_assed_limit
          ? user.final_form_submitted_data.final_assed_limit
          : 0;
      let existingDp =
        user && user.user_docs && user.user_docs.existing_dp ? user.user_docs.existing_dp : 0;
      let breStatus = user && user.bre_status ? user.bre_status : 'Nil';
      let createdDate = user && user.created ? user.created : '';
      let isRejected = user && user.rejectLoan ? user.rejectLoan : false;

      let date1 = new Date();
      let date2 = new Date(createdDate);
      let timeInMilisec = date1.getTime() - date2.getTime();
      let daysBetweenDates = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));

      if (breStatus && (breStatus == 'Failure' || breStatus == 'failure')) {
        return 'Failure';
      // } else if (daysBetweenDates > 90) {
      //   return 'Pending';
      } else if (isRejected) {
        return 'Failure';
      } else if (
        finalAssLimit &&
        existingDp &&
        breStatus &&
        (breStatus == 'success' || breStatus == 'Success')
      ) {
        if (finalAssLimit >= existingDp) {
          return 'Success';
        } else if (finalAssLimit < existingDp) {
          return 'Processing';
        }
      } else {
        return 'Pending';
      }
    }
  }

  openLandRecords(user, custId) {
    console.log(user);
    sessionStorage.setItem('applicantId', user);
    sessionStorage.setItem('wl-applicant-id', user);
    sessionStorage.setItem('lrOpenedFromAdmin', 'false');


    this.auth.userLogin('test@123', custId).subscribe((res) => {
      console.log('Login User', res);
      if (res && res.custId && res.custId.length > 0) {
        sessionStorage.setItem('lrOpenedFromAdmin', 'false');
        this.token.selectedstateCode.subscribe((value) => {
          console.log(value);
        });
        let stateCode = sessionStorage.getItem(constants.ROUTE_KEY);
        if (stateCode == constants.STATES.KA.KEY) {
          window.open(ENV.urlSetting.url + 'laas/land-records-ka');
        } else if (stateCode == constants.STATES.MP.KEY) {
          window.open(ENV.urlSetting.url + 'laas/land-records-mp');
        }else if(stateCode == constants.STATES.AD.KEY){
          window.open(ENV.urlSetting.url + 'laas/land-records-ap');
        }
      }
      // this.getAllUsers("", this.roleId, 0, 10);
    });
  }

  checkforrepaymentstatus(i) {
    /*     console.log(this.allUsers[i]['user_docs']['existing_loan_details']['outstanding_as_on'],'this.allUsers[i][dfdf]'); */
    if (
      this.allUsers &&
      this.allUsers[i] &&
      this.allUsers[i] &&
      this.allUsers[i]['user_docs'] &&
      this.allUsers[i]['user_docs']['existing_loan_details'] &&
      this.allUsers[i]['user_docs']['existing_loan_details']['outstanding_as_on'] >= 0
    ) {
      return 'Yes';
    } else {
      /* console.log(this.allUsers[i]['user_docs']['existing_loan_details']['outstanding_as_on'],'checkforrepaymentstatus');  */
      return 'No';
    }
  }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateDashboardStart');
    sessionStorage.removeItem('filterDateDashboardEnd');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  storageListener() {
    // console.log("test")
    if (sessionStorage.getItem('submitted') && sessionStorage.getItem('submitted') == 'submitted') {
      // this.getAllUsers("", this.roleId, 0, 10);
      // this.ngOnInit()
      //   this.router.navigateByUrl('/ViewCustomerComponent', { skipLocationChange: true }).then(() => {
      //     this.router.navigate(['/ViewDashboardComponent']);
      // });
      window.location.reload();
    }
  }

  isCoLogin() {
    if (this.roleId === '1') {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showDashboardDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    try {
      this.customer.getDashboard(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          let resultSet =
            response && response.result && response.result.resultData
              ? response.result.resultData
              : [];
          this.allUsers = resultSet;
          if (!resultSet.length) {
            this.noUserFound = 'Customer data not found';
          }

          this.totalCount =
            response && response.result && response.result.count ? response.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.totalCount = 0;
          this.totalPage = 0;
          this.loading = false;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.totalCount = 0;
      this.totalPage = 0;
      this.loading = false;
    }
  }
}
